import { render, staticRenderFns } from "./MarketplaceItem.vue?vue&type=template&id=a8b76612&scoped=true&"
import script from "./MarketplaceItem.vue?vue&type=script&lang=js&"
export * from "./MarketplaceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b76612",
  null
  
)

export default component.exports